import {
  Content,
  Footer,
  Header,
  PageContainer,
} from '../../components/blocks';
import React, { useMemo, useState } from 'react';
import UnsubscribeForm from './UnsubscribeForm';
import { UnsubscribeNextContext } from './context';
import UnsubscriptionSuccess from './UnsubscriptionSuccess';
import ResubscribeSuccess from './ResubscribeSuccess';
import UnsubscriptionError from './UnsubscriptionError';

export default function UnsubscribeNext() {
  /**
   * 5 pages: unsubscribe, reason, success, resubscribe, error (failed to fetch status, could be due to invalid token)
   */
  const [page, setPage] = useState('unsubscribe');
  const renderContent = useMemo(() => {
    switch (page) {
      default:
      case 'unsubscribe':
        return <UnsubscribeForm />;
      case 'success':
        return <UnsubscriptionSuccess />;
      case 'resubscribe':
        return <ResubscribeSuccess />;
      case 'error':
        return <UnsubscriptionError />;
    }
  }, [page]);
  return (
    <UnsubscribeNextContext.Provider value={{ page, setPage }}>
      <PageContainer>
        <Header title="Unsubscribe" />
        <Content>{renderContent}</Content>
        <Footer />
      </PageContainer>
    </UnsubscribeNextContext.Provider>
  );
}
